/**
 * The in-thread question card's frame (agion/Agion#3446, challenge
 * 2026-10-26-escalation-question-chat-card C1): a HITL request whose
 * governance_context carries question_card true refers to a question
 * escalation and holds nothing else of it. The chat draws the card from
 * governance and never treats the frame as an answerable question.
 */

import type { GovernanceContext } from '../types/streaming'

/** What a chat row keeps of a question card frame: the escalation it names, when it names one. */
export interface QuestionCardRef {
  escalationId?: string
}

/** The card a frame refers to, or undefined when the frame is not a question card. */
export function questionCardOf(governance: GovernanceContext | undefined): QuestionCardRef | undefined {
  if (governance?.question_card !== true) return undefined
  const id = governance.escalation_id
  return typeof id === 'string' && id !== '' ? { escalationId: id } : {}
}
